// extracted by mini-css-extract-plugin
export default {"search":"Search_search__eImIR","input":"Search_input__b2Nfs","icon":"Search_icon__s5745"};